module.exports = __webpack_public_path__ + "img/deduction.fe1abbb4.png";